import axios, { AxiosResponse } from "axios";
import React, { useEffect, useState, useContext } from "react";
import SearchBar from "./SearchBar";
import { config } from "../../contexts/UrlContext";
import { toast } from "react-toastify";
import { Table, Icon, Dimmer, Loader, Button, SemanticWIDTHS, SemanticICONS, Popup } from 'semantic-ui-react';
import { requestSort, SORT_ICON, SORT_ORDER } from "../../services/SortService";
import { IGrid } from "../Interfaces/TableInterface";
import history from "../../History";
import PaginationNav from "../Results/PaginationNav";
import TableItem from "./TableItem";
import { SettingsContext } from "../../contexts/SettingsContext";
import AuthContext from "../../contexts/AuthContext";
import { getRequest } from "../../services/axiosService";


function Home() {

    const { auth} = useContext(AuthContext);

    const [loadingText, setLoadingText] = useState("Loading CM2WebShare");
    const [loading, setLoading] = useState<boolean>(true);
    const [tables, setTables] = useState<any[]>([]);

    const [totalPages, setTotalPages] = useState<number>(1);
    const [activePage, setActivePage] = useState<number>(1);
    const [totalResults, setTotalResults] = useState<number>(0);

    const [sortIcon, setSortIcon] = useState<SemanticICONS>(SORT_ICON.ASC);
    const [sortOrder, setSortOrder] = useState(SORT_ORDER.ASC);
    const [currentSortName, setCurrentSortName] = useState<string>("");

    const [filter, setFilter] = useState<string>("name");
    const [searchString, setSearchString] = useState<string>("");

    const { hasAdminPrivileges } = useContext(SettingsContext);

    useEffect(() => {
        async function getData() {
            getResults("" , 1);
            setLoading(false);
        }

        getData();
    }, []);

    const getResults = async (queryString: string, page: number) => {
        setLoadingText("Searching Tables");
        setLoading(true);
        let query;

        if (queryString)
            query = `/Home/GetTableDisplay?filter=${filter}&search=${queryString}&page=${page.toString()}`;
        else
            query = `/Home/GetTableDisplay?page=${page.toString()}`

        try {
            let response: AxiosResponse = await getRequest(auth, query);

            let data = response.data;
            if (data !== null) {
                setTables(data.results);
                setTotalPages(data.totalPages);
                setTotalResults(data.totalResults);
                setActivePage(page);
            }
        } catch (error) {
            let e: any = error;
            console.log(e.response.data)
            console.log(error);
            toast.error(`Unable to get CM2WebShare Tables. Please see logs for more info`);
        }
        setLoading(false);
    }

    const handlePaginationChange = async (activePage: number) => {
        setLoadingText("Loading CM2WebShare Tables");
        setLoading(true);
        setActivePage(activePage);
        await paginateResults(activePage);
        // scroll to top of page
        let mainDiv: any = document.getElementById('site-content');
        mainDiv.scrollTop = 0;
        setLoading(false);
    }

    const paginateResults = async (currentPage: number) => {
        await getResults(searchString, currentPage);
    }

  
    const unlockTable = (id: string) => {
        try {
            let temp = tables;
            temp.find((table: IGrid) => table.id === id).checkedOutTo = null;
            setTables([...temp]);
            setLoading(false);
            toast.success("Table has been unlocked");
        }catch(error){
            console.log(error);
            toast.error(`Unable to unlock table. Please check logs`);
            setLoading(false);
        }
    }

    const deleteTable = (id: string) => {
        try
        { 
            let newTables = tables.filter((table: IGrid) => table.id !== id);
            setTables(newTables);
            setTotalResults(totalResults - 1);
            toast.success(`Table successfully deleted`);
        }catch(error) {
            console.log(error);
            toast.error(`Unable to delete table. Please check logs`);
        }
    }
    
    const onFilterChange = (e: any) => {
        setFilter(e);
    }

    const onSearchStringChange = (e:any) => {
        setSearchString(e);
    }

    if (loading) {
        return (
            <Dimmer inverted active={true}>
                <Loader inverted>{loadingText}...</Loader>
            </Dimmer>
        );
    }
    else {
        return (
            <div className="ui container" style={{ borderBottom: "0", maxWidth: "100%", marginTop: 15 , width:'70%'}} id="home">
                <SearchBar filter={filter} filterCallback={onFilterChange} searchString={searchString} onSearchChange={onSearchStringChange} onResultsCallback={getResults} />
                <div className="meta" style={{ marginLeft: 10 }}>Total Results: {totalResults}</div>
                <Table stackable id="homeTable" style={{ marginLeft: 10, width:'99%' }}>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell width={2} onClick={() => requestSort("name", "string", "name", setCurrentSortName, setSortIcon, setSortOrder, sortOrder, setTables, tables, false)}>
                                Name{currentSortName == "name" ? <Icon name={sortIcon} /> : <Icon name={SORT_ICON.DEFAULT} />}</Table.HeaderCell>
                            <Table.HeaderCell width={2} onClick={() => requestSort("description", "string", "description", setCurrentSortName, setSortIcon, setSortOrder, sortOrder,  setTables, tables, false)}>
                                Description{currentSortName == "description" ? <Icon name={sortIcon} /> : <Icon name={SORT_ICON.DEFAULT} />}</Table.HeaderCell>
                            <Table.HeaderCell width={2}  onClick={() => requestSort("lastUpdatedBy", "string", "lastUpdatedBy", setCurrentSortName, setSortIcon, setSortOrder, sortOrder, setTables, tables, false)}>
                                Updated By{currentSortName == "lastUpdatedBy" ? <Icon name={sortIcon} /> : <Icon name={SORT_ICON.DEFAULT} />}</Table.HeaderCell>
                            <Table.HeaderCell width={2} onClick={() => requestSort("lastUpdatedDate", "date", "lastUpdatedDate", setCurrentSortName, setSortIcon, setSortOrder, sortOrder, setTables, tables, false)}>
                                Date Last Updated{currentSortName == "lastUpdatedDate" ? <Icon name={sortIcon} /> : <Icon name={SORT_ICON.DEFAULT} />}</Table.HeaderCell>
                            <Table.HeaderCell width={2}>Actions</Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body id="search-results">
                        {tables.map(function (table: IGrid) {
                            return (
                                <TableItem key={table.id} id={table.id} table={table} onDelete={deleteTable} onUnlock={unlockTable} setLoading={setLoading} setLoadingText={setLoadingText } />
                            )
                        })}
                    </Table.Body>
                </Table>
                <div className="resultsNav" style={{ marginTop: "20px", paddingBottom: "20px" }}>
                    <PaginationNav totalPages={totalPages} onChange={handlePaginationChange} activePage={activePage} />
                </div>

                {hasAdminPrivileges && (
                    <div style={{ display: "flex", alignItems: "flex-end", justifyContent: "left", alignContent: "stretch", margin: 10, paddingBottom: 50 }}>
                        <Button id="new-table" onClick={() => history.push("/CM2WebShare/GridSettings")}>Create New Table</Button>
                    </div>
                )}
                
            </div>
        );
    }
}

export default Home;